export default {
  id: '',
  outlet_desc: '',
  outlet_address: '',
  outlet_contact: '',
  isDeleted: '',
  updatedBy: '',
};
